import { css } from '@emotion/react';

import type { FormControlProps } from './FormControl';
import { FormControl } from './FormControl';

const helperTextStyles = css({
	display: 'grid',
	gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
	gridTemplateColumns: '1fr auto',
	columnGap: '1rem',
});

function getLength(value: unknown) {
	if (typeof value === 'string') {
		return value.length;
	}
	return 0;
}

interface FormControlLengthProps extends FormControlProps {
	value: unknown;
	maxLength: number;
	/**
	 * Controls whether the length of the input value is displayed.
	 * Set to `true` to show the length (default behavior).
	 * Set to `false` to hide the length unless the input exceeds `maxLength`.
	 */
	showLength?: boolean;
}
export function FormControlLength(props: FormControlLengthProps) {
	const { value, maxLength, showLength = true } = props;
	const fieldLength = getLength(value);
	const lengthDisplay = `${fieldLength}/${maxLength}`;

	const error = props.error || fieldLength > maxLength;

	return (
		<FormControl
			{...props}
			error={error}
			helperText={
				<div css={helperTextStyles}>
					<div>{props.helperText}</div>
					{showLength || fieldLength > maxLength ? (
						<div>{lengthDisplay}</div>
					) : null}
				</div>
			}
		/>
	);
}
